import { masterConstants } from "./masterConstants";

const masterActions = {};

masterActions.getRMSRiskAssessmentQuestions = () => (
    {
        type: masterConstants.RMS_RISK_ASSESSMENT_QUESTIONS_SAGA,
    });

masterActions.getRMSRiskProfiles = () => ({
    type: masterConstants.RMS_RISK_PROFILES_SAGA,
});

masterActions.getMasterBrokers = ({ isFetchHoldingEnabled, isIntegrated, searchTerm, productCode } = {}) => ({
    type: masterConstants.MASTER_BROKER_SAGA,
    payload: { isFetchHoldingEnabled, isIntegrated, searchTerm, productCode }
})

masterActions.getRiskDetails = (payload) => ({
    type: masterConstants.RiSK_PROFILE_DATA,
    payload,
});


// masterActions.getOnestockMasterBrokers = ({ isFetchHoldingEnabled, isIntegrated, searchTerm, productCode } = {}) => ({
//     type: masterConstants.ONESTOCK_MASTER_BROKER_SAGA,
//     payload: { isFetchHoldingEnabled, isIntegrated, searchTerm, productCode }
// })

masterActions.getPendingCall = () => ({
    type: masterConstants.PENDING_CALL_SAGA,
});

masterActions.getFirstRender = (payload) =>({
    type : masterConstants.FIRST_TIME_RENDER,
    payload,
})

masterActions.submitScheduleCall = (payload) => ({
  type: masterConstants.SUBMIT_SCHEDULE_CALL_SAGA,
  payload,
});



export { masterActions };
